<script setup>
  import { storeToRefs } from "pinia";
  import NavButton from "@/components/App/NavButton.vue";
  import { useSurveyStore } from "@stores/survey/survey";
  import { useSurveyErrorsStore } from "@stores/survey/surveyErrors";
  import { useSurveyCardsSettingsStore } from "@stores/surveyCardsSettings";

  const surveyStore = useSurveyStore();
  const surveyErrorsStore = useSurveyErrorsStore();
  const surveyCardsSettingsStore = useSurveyCardsSettingsStore();

  const { hasSurveyChanged } = storeToRefs(surveyStore);
  const { hasErrors } = storeToRefs(surveyErrorsStore);
  const { haveSetupCardsChanged } = storeToRefs(surveyCardsSettingsStore);
  const { saveSetupCards } = surveyCardsSettingsStore;

  async function saveResultsSetup() {
    await surveyStore.saveResultsSettings();
    await saveSetupCards();
  }
</script>

<template>
  <NavButton
    :can-trigger="haveSetupCardsChanged || hasSurveyChanged"
    :has-errors="hasErrors"
    :action-function="saveResultsSetup" />
</template>
